<template>
  <div id="app" v-if="curso">
    <router-view/>
  </div>
</template>

<script>

import { cargarDatosCurso } from './curso.js';

export default {
	name: 'App',
    data () {
        return {
            curso: null,
        }
    },
	beforeCreate() {
		cargarDatosCurso().then((data) => this.curso = data);
	}
}
</script>
